// Prevent multiple form submit
$('form').submit(function(){
    $(this).find('button[type="submit"]').prop('disabled', true);
});

// TODO: workaround - needs better implementation
$('form').change(function() {
    $(this).find('button[type="submit"]').prop('disabled', false);
});

document.querySelectorAll("a[data-cf-turnstile-reset]").forEach(btn => {
    btn.addEventListener('click', () => {
        plausible('Cloudflare Turnstile', {props: {action: 'Reset button clicked'}});
    })
});
